export const formatearDireccionEntrega = (direccionEntrega = {}, opciones = {}) => {
  const { mostrarReferencia = false } = opciones;
  if (!direccionEntrega) return { referencia: "", direccion: "" };

  const calle = [
    direccionEntrega.calle,
    direccionEntrega.numeroCalle ? `#${direccionEntrega.numeroCalle}` : "",
    direccionEntrega.numeroInterior ? `Int. ${direccionEntrega.numeroInterior}` : "",
  ].filter(Boolean).join(" ");

  const coloniaCp = [
    direccionEntrega.colonia,
    direccionEntrega?.cp?.cp ? `C.P. ${direccionEntrega.cp.cp}` : "",
    direccionEntrega?.municipio?.nombre,
    direccionEntrega?.estado?.nombre,
    direccionEntrega?.pais?.nombre,
  ].filter(Boolean).join(" ");

  return {
    referencia: mostrarReferencia && direccionEntrega.referencia ? direccionEntrega.referencia : "",
    direccion: [calle, coloniaCp].filter(Boolean).join(", "),
  };
};
